import { createContext, useContext } from "react";

export type ViewableFile = {
  file_url: string | null | undefined;
  file_name: string;
  mime_type?: string | null;
  /**
   * ``UserUploadedFile.uuid`` of a protected file. When present, the viewer
   * streams the bytes through the authenticated, non-expiring file-view proxy
   * (``/api/files/<uuid>/view/``) instead of loading the signed ``file_url``
   * directly - so a day-old cached payload with an expired signed URL still
   * previews (TA-23). Falls back to ``file_url`` when absent.
   */
  file_uuid?: string | null;
};

export type FileViewerContextValue = {
  openFile: (file: ViewableFile) => void;
};

export const FileViewerContext = createContext<FileViewerContextValue | null>(
  null,
);

export function useFileViewer(): FileViewerContextValue {
  const ctx = useContext(FileViewerContext);
  if (!ctx) {
    // Fallback so callers outside the provider still get sane behavior
    // (open in a new tab) instead of crashing.
    return {
      openFile: (file) => {
        if (file.file_url) {
          window.open(file.file_url, "_blank", "noopener,noreferrer");
        }
      },
    };
  }
  return ctx;
}
